module.exports = __webpack_public_path__ + "static/headshot-catherine-52eaf705830a60f61501af2426e084bc.avif";